module.exports = __webpack_public_path__ + "img/582c57b2b274e6dc04761aa5de6d561b.png";